import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import structuredData from '../seo/structured-data';

const { getRouteSchemas } = structuredData;

// Route-level schema.org JSON-LD (Organization on every page, plus
// SoftwareApplication / BreadcrumbList where they apply). Replaces the static
// set baked into the route HTML by scripts/generate-route-html.js, which only
// matches the initially loaded route.
const SeoStructuredData = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document
      .querySelectorAll('script[data-seo-jsonld]')
      .forEach((node) => node.remove());

    const scripts = getRouteSchemas(pathname).map((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.dataset.seoJsonld = 'route';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      return script;
    });

    return () => {
      scripts.forEach((script) => script.remove());
    };
  }, [pathname]);

  return null;
};

export default SeoStructuredData;
